import { EuiButtonIcon, EuiFlexGroup } from "@inscopix/ideas-eui";
import { NodeProps, Node } from "@xyflow/react";
import { capitalize } from "lodash";
import { colorsByRunStatus } from "types/ColorsByRunStatus";
import { RunStatus } from "types/constants";
import { NodeDataBase } from "../WorkflowDiagramReactFlow";
import { nodeStyles } from "./nodeStyles";
import { StepNode } from "./StepNode";

export type RunStatusNodeProps = NodeProps<
  Node<NodeDataBase & { runStatus: RunStatus | undefined }>
>;
export const RunStatusNode = ({ ...props }: RunStatusNodeProps) => {
  return (
    <StepNode
      backgroundColor={
        props.data.runStatus !== undefined
          ? colorsByRunStatus[props.data.runStatus]
          : "lightGray"
      }
      {...props}
      data={{
        ...props.data,
        subLabel:
          props.data.runStatus === undefined
            ? "(Not Started)"
            : `(${capitalize(RunStatus[props.data.runStatus])})`,
      }}
      header={
        <EuiFlexGroup
          alignItems="center"
          justifyContent="flexEnd"
          style={nodeStyles.headerFlexContainer}
          gutterSize="none"
        >
          <EuiButtonIcon
            iconType="tableDensityExpanded"
            color="text"
            size="xs"
          />
          <EuiButtonIcon iconType="compute" color="text" size="xs" />
        </EuiFlexGroup>
      }
    />
  );
};
